import PropTypes from 'prop-types';
import { css, cx } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { DangerousHtmlContent } from '@eti/components';
import { Text, textVariants } from '@etg/wings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = css`
  padding: 30px 15px 55px;
`;
const emailStyles = css`
  font-weight: 600;
`;
const SimpleVisaNextStepInfo = ({
  contactEmail,
  className
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs("div", {
    className: cx(wrapperStyles, className),
    children: [/*#__PURE__*/_jsx(Text, {
      variant: textVariants._16_BOLD,
      children: t('Products.SimpleVisa.NextStepInfo.Header')
    }), /*#__PURE__*/_jsx(DangerousHtmlContent, {
      content: t('Products.SimpleVisa.NextStepInfo.Text')
    }), contactEmail && /*#__PURE__*/_jsx("div", {
      className: emailStyles,
      children: contactEmail
    })]
  });
};
SimpleVisaNextStepInfo.propTypes = {
  className: PropTypes.string,
  contactEmail: PropTypes.string
};
export default SimpleVisaNextStepInfo;
//# sourceMappingURL=SimpleVisaNextStepInfo.js.map